import { DndContext, DragEndEvent, closestCorners } from "@dnd-kit/core";
import { SortableContext, arrayMove, horizontalListSortingStrategy } from "@dnd-kit/sortable";

import PreviewItem, { IPreviewItem } from "~/components/PreviewItem";

import "./style.less";

interface IUploadPreviews {
	items: Array<IPreviewItem>;
	onUpload?: (item: IPreviewItem, file: File) => void;
	onError?: (item: IPreviewItem, msg: string) => void;
	onRemove?: (item: IPreviewItem) => void;
	onReorder?: (orderedItems: Array<IPreviewItem>) => void;
}

export default function UploadPreviews({
	items,
	onUpload = () => {},
	onError = () => {},
	onRemove = () => {},
	onReorder = () => {},
}: IUploadPreviews) {
	function getItemPos(id: string) {
		return items.findIndex(item => item.id === id);
	}

	function onDragEnd(event: DragEndEvent) {
		const { active, over } = event;

		if (!active || !over || active.id === over.id) {
			return;
		}

		const originalPos = getItemPos(active.id as string);
		const newPos = getItemPos(over.id as string);
		const newItems = arrayMove(items, originalPos, newPos);

		onReorder(newItems);
	}

	return <DndContext collisionDetection={closestCorners} onDragEnd={onDragEnd}>
		<div className="uploadPreviews">
			<SortableContext items={items} strategy={horizontalListSortingStrategy}>
				{ items.map((item, ind) => <PreviewItem key={item.id} data={item} onUpload={file => onUpload(item, file)} onError={msg => onError(item, msg)} onRemove={() => onRemove(item)} firstItem={ind === 0} />) }
			</SortableContext>
		</div>
	</DndContext>;
}
